import React, { useState, useEffect,useContext } from "react";
import axios from "axios";
import useInfiniteScroll from "./../../helpers/useInfinite"
import api from '../../services/api';
import Loading from '../../helpers/loading';
import { Link, useHistory } from 'react-router-dom';
import {useParams} from "react-router-dom";
import { QRCode } from "react-qr-svg";
import M from "materialize-css";
import "materialize-css/dist/css/materialize.min.css";
import Error from '../../helpers/error';
import { PageContext } from './../../contexts/PageContextProvider';
import LoadingScreen from '../Loading'
import './styles.css';

const Cupons = () => {

  const [loading, setLoading] = useState(true)
  const { user } = useContext(PageContext);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [qrcode, setQrCode] = useState('');
  const [company, setCompany] = useState([]);


  const [lastPage, setLastPage] = useState(1);
  const [current_page, setCurrent_page] = useState(1);
  const [isFetching, setIsFetching] = useInfiniteScroll(moreData);
  const history = useHistory();



  // set variable
  let token = localStorage.getItem('token');
  // let qrcode='123456';

  // let url = `companies`;

  function loadData() {

      if (page <= lastPage) {
            let url = `points-extract?page=${page}`;
            try {

                  api.get(url,
                      {
                          headers: {"Authorization" : `Bearer ${token}`} 
                      }
                  ).then(res => {
                      setData([...data, ...res.data.data]);
                      setCompany(res.data);
                      setLastPage(res.data.last_page);
                      setPage(page+1)
                      setIsFetching(false)

                      setLoading(false)
                });
      } catch (error) {

      // alert(error)
  
        // console.log(error)
  
        // setFormError(true);
        //     var errorsList= error.response.data.errors
  
        //     var Msg='';
        //     Object.keys(errorsList).map((key) => {
        //         Msg= Msg + errorsList[key] + '<br/>';
        //     });
  
        //     toast.error('Foram encontrados alguns erros!');
  
        //     MySwal.fire({
        //       icon: 'error',
        //       title: "OPS!", 
        //       html: Msg,  
        //       confirmButtonText: "OK", 
        //     });
      }
      }
  }


  function back() {   
    history.push(`/fidelidade`);
   
  }


  function getCupom(id) {   
    
    setQrCode(id);
    var elem= document.querySelector('.modal');
    var instance = M.Modal.init(elem);
    instance.open();
    
  }


  function moreData() {    
    loadData()
  }

  function getCupom(id) {
    setQrCode(id);
    var elem= document.querySelector('.modal');
    var instance = M.Modal.init(elem);
    instance.open();
  }


  useEffect(()=>{
    setTimeout(() => setLoading(false), 1000)
    loadData()
  }, [])


  if (loading) {
    return (  <LoadingScreen />);
  }


  if (!user.approved) {
      return (<Error message="Seu acesso ainda não foi autorizado!"></Error>);
  }

  if (!user.active) {
      return (<Error message="Seu acesso foi bloqueado, fale com seu gerente!"></Error>);
  }
  if (data.length==0) {
    return (<Error message="Nenhuma movimentação de pontos" ></Error>);
  }

  return (
    <>
       {loading === false ? (
        <div className='section'>

           <div id="modal1" className="modal">
              <div className="modal-content">
                 <p>Apresente este <b>QR-Code</b> para impressão do cupom. </p>
                <QRCode
                bgColor="#FFFFFF"
                fgColor="#000000"
                level="Q"
                value={qrcode}
            />
              </div>
              <div className="modal-footer">
                <a className="modal-action modal-close waves-effect waves-green btn-flat">OK</a>
              </div>
            </div>
           <div className='container'>
              <div className="row">
                <div className="col s8">
                    <h6><b>Meus Pontos</b></h6>
                </div>
              </div>
              {data.map((item, key) => (
              <div className="col s12"  key={key}>
                <div  className={`card-panel credit-${item.id_category}`}>

                <div className="row">
                    <div className="col s9">
                          <b>{item.company}</b> <br></br>
                        
                          <b>{item.category}</b> <br></br>
                           {item.code}<br></br>
                           {item.name}<br></br>
                           
                {item.id_category == 3  &&
                    <span className="code"><br></br> Crédito adicionado pelo seu gerente  {item.admin}.</span>
                  }


                           <span className="code">*Solicitado em  {item.points_date}</span>
                    </div>

                    <div className="col s1">

                                  <b>Ponto: {item.points}</b> 
                    </div>


                  {item.id_category == 2  &&
                  <div
                  
                  
                  className="row center-align">

                      {item.admin_low == false  &&
                        <a className="myButton "  onClick={() => getCupom(item.qr_code)}><i className="material-icons mini-icon">qr_code</i> Trocar pontos </a>
                      }

                
                 
                 
                  </div>
                  }

                  {item.admin_low == true  &&
                          <span className="code1"> <i className="material-icons mini-icon">qr_code</i> Troca realizada!</span>
                    }
                 


                </div>
                </div>
              </div>
                ))}
           </div>
        </div>
   ) : (
    <LoadingScreen />
  )}
  </>
  );
};

export default Cupons;